import fetch from "../components/Fetchinterceptor/FetchInterceptor";


const departmentsService = {}
const apiRoute = '/departments';

departmentsService.getAll = async function (query = '') {
    try {
        const res = await fetch({
            url: `${apiRoute}/getAll/public${query}`,
            method: 'get'
        });
        return res;
    } catch (err) {
        console.log(err, 'show-err');
        return err
    }
}

departmentsService.getById = async function (id) {
    try {
        const res = await fetch({
            url: `${apiRoute}/get/public/${id}`,
            method: 'get',
        })
        return res
    } catch (err) {
        console.log(err, 'show-err')
    }
}

departmentsService.getBySlug = async function (slug) {
    try {
        const res = await fetch({
            url: `${apiRoute}/get/slug/${slug}`,
            method: 'get',
        })
        return res
    } catch (err) {
        return err
        console.log(err, 'show-err')
    }
}

export default departmentsService;